import React from 'react'
import { THEME } from 'utils'
import Twitter from 'icons/Twitter'
import Instagram from 'icons/Instagram'
import TikTok from 'icons/TikTok'

const AuthorHero = ({ author }) => {
  return (
    <>
      <section className='authorHero' style={{ backgroundImage: `url(${author.headshot})` }}>
        <div className='container'>
          <div className='authorInfo'>
            <div className='authorInfo__text'>
              <h1 className='authorInfo__name'>{author.name}</h1>
              {author.bio && <p className='authorInfo__bio'>{author.bio}</p>}
              <div className='authorInfo__actions'>
                {author.twitter_handle && (
                  <a target='_blank' rel='noreferrer noopener' href={`https://twitter.com/${author.twitter_handle}`}>
                    <Twitter color='#666666' height='18px' width='auto' />
                  </a>
                )}
                {author.instagram && (
                  <a target='_blank' rel='noreferrer noopener' href={`https://instagram.com/${author.instagram}`}>
                    <Instagram color='#666666' height='18px' width='auto' />
                  </a>
                )}
                {author.tiktok && (
                  <a target='_blank' rel='noreferrer noopener' href={`https://tiktok.com/@${author.tiktok}`}>
                    <TikTok fill='#666666' height='18px' width='auto' />
                  </a>
                )}
              </div>
            </div>
          </div>
          {author.headshot && <img className='authorInfo__headshot' src={author.headshot} />}
        </div>
      </section>
      <style jsx>{`
        .authorHero {
          background-color: #fff;
          padding-top: 8px;
          border-bottom: 1px solid ${THEME.COLORS.LIGHTGRAY};
          background-repeat: no-repeat;
          background-position: 100% 100%;
          background-size: auto 86%;
        }
        .authorHero .container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 1rem;
          min-height: 13rem;
        }
        .authorInfo {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
        }
        .authorInfo__name {
          font-family: ${THEME.FONTS.BEBAS};
          font-weight: 700;
          font-size: 2rem;
          letter-spacing: 0;
          line-height: 1.3;
          margin: 0;
          text-align: left;
        }
        .authorInfo__bio {
          font-family: ${THEME.FONTS.HELVETICA};
          font-size: 0.75rem;
          margin: 0.1875rem 0 0.375rem;
          line-height: 1.3;
          max-width: 45%;
          text-align: left;
        }
        .authorInfo_actions {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
        }
        .authorInfo__actions a {
          display: inline-block;
          padding: 0.5rem 0;
          margin-right: 1.25rem;
        }
        .authorInfo__headshot {
          display: none;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .authorHero {
            margin-top: -20px;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
          .authorHero {
            background-image: none !important;
          }
          .authorHero .container {
            min-height: 15.625rem;
            justify-content: flex-start;
          }
          .authorInfo {
            flex-direction: row;
            align-items: flex-start;
            text-align: left;
          }
          .authorInfo__name {
            font-size: 3rem;
          }
          .authorInfo__bio {
            font-size: 1rem;
            line-height: 1.5;
            max-width: 34.375rem;
          }
          .authorInfo__actions {
            justify-content: flex-start;
            flex-direction: row;
          }
          .authorInfo__headshot {
            display: block;
            width: 39.375rem;
            height: 22.5rem;
          }
        }
      `}</style>
    </>
  )
}

export default AuthorHero
